import React, { useMemo } from 'react'
import { IndividualPermissionProvider } from '@/components/changeRequests/individualPermissionProvider'
import { individualPermissionTypes } from '@/enums/individualPermissionTypes'
import { PropertyRenderer } from '@/components/changeRequests'
import { Column, DateCell, DateFilterCell, actionButtonsColumnProps } from '@/components/BsrsGrid'
import { useLocalization } from '@/hooks/localization'
import { usePermissionChecker } from '@/hooks/usePermissionChecker'
import { GridCell } from '@progress/kendo-react-grid'

const ActiveStatusCell = ({ localize }) => class extends GridCell {
  render () {
    const dataItem = this.props.dataItem
    if (!dataItem) return <td />

    const { isActive, validTo } = dataItem
    const isCurrentlyActive = isActive && !validTo
    return <td>{localize(isCurrentlyActive ? 'Common.Active' : 'Common.Inactive')}</td>
  }
}

const IndividualUserHistory = React.memo(function IndividualUserHistory ({ dataSource }) {
  const { localize } = useLocalization()
  const isGranted = usePermissionChecker()
  const defaultSort = useMemo(() => ([{ field: 'validFrom', dir: 'desc' }]), [])

  const actionButtons = useMemo(() => {
    if (!isGranted('CanManageUsers')) return []
    return [
      { icon: 'show', url: (item) => `/users/${item.userId}` }
    ]
  }, [isGranted])

  const StatusCell = useMemo(() => ActiveStatusCell({ localize }), [localize])

  return (
    <IndividualPermissionProvider individualPermission={individualPermissionTypes.enum.IndividualUserAccounts}>
      <PropertyRenderer name='individualUserHistory' inputType='grid' dataSource={dataSource} readonly defaultSort={defaultSort}>
        <Column field='userId' title={localize('Common.UserId')} filter='numeric' width='100px' />
        <Column field='userName' title={localize('UsersManagement.UserName')} />
        <Column field='institutionName' title={localize('Institutions.Institution')} />
        <Column field='validFrom' title={localize('Common.ValidFrom')} filter='date' filterCell={DateFilterCell} cell={DateCell} />
        <Column field='validTo' title={localize('Common.ValidTo')} filter='date' filterCell={DateFilterCell} cell={DateCell} />
        <Column field='isActive' title={localize('Common.Status')} cell={StatusCell} />
        {actionButtons.length > 0 && <Column {...actionButtonsColumnProps(actionButtons)} />}
      </PropertyRenderer>
    </IndividualPermissionProvider>
  )
})

export { IndividualUserHistory }



// WEBPACK FOOTER //
// ./src/components/demographics/individualUserHistory.js